<template>
  <div></div>
</template>

<script>
export default {
  name: 'confirm-affiliate',
  created() {
    this.loader = this.$loading.show()
  },
  data() {
    return {
      loader: ''
    }
  },
  async mounted() {
    const affiliateId = this.$route.query.code
    if (affiliateId) {
      await this.axios
        .post(process.env.VUE_APP_ROOT_API + '/api/v1/affiliates/confirm', {
          code: affiliateId
        })
        .then(async (_) => {
          await this.$router.push({ name: 'Confirmed Success' })
        })
        .catch((err) => {
          this.$router.push({ name: 'Dashboard' })
        })
    } else {
      await this.$router.push({ name: 'Dashboard' })
    }
  },
  destroyed() {
    this.loader.hide()
  }
}
</script>
